/**
 * Convierte el DataEjecucion de un detalle en un objeto para mostrarlo. Nunca lanza: se usa dentro del
 * render de DataTables, donde una excepción deja la tabla en "Procesando...". Hay registros históricos
 * con texto plano, como los errores de las tareas de tipo plantilla.
 */
export function parsearDataEjecucion(data: string): any {
  try {
    const valor = JSON.parse(data);
    return typeof valor === 'object' && valor !== null ? valor : { Detalle: data };
  } catch {
    return { Detalle: data };
  }
}
